import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { DataResolverService } from './resolver/data-resolver.service';
import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'signin',
        pathMatch: 'full'
    },
    {
        path: 'login',
        loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule)
    },
        {
        path: 'logon',
        loadChildren: () => import('./logon/logon.module').then(m => m.LogonPageModule)
    },
     {
    path: 'payment-callback',
    loadChildren: () => import('./payment-callback/payment-callback.module').then( m => m.PaymentCallbackPageModule)
  },
    {
        path: 'signin',
        loadChildren: () => import('./signin/signin.module').then(m => m.SigninPageModule)
    },
    {
        path: 'signup',
        loadChildren: () => import('./pages/signup/signup.module').then(m => m.SignupPageModule)
    },
    {
        path: 'onboarding',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingPageModule)
    },
        {
        path: 'news',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./news/news.module').then(m => m.NewsPageModule)
    },
    {
        path: 'accounts',
        canActivate: [AuthGuard],
        loadChildren: () => import('./accounts/accounts.module').then(m => m.AccountsPageModule)
    },
    {
        path: 'qrcode',
        loadChildren: () => import('./accounts/qrcode/qrcode.module').then(m => m.QRCodePageModule)
    },
    {
        path: 'loyalty-points',
        loadChildren: () => import('./accounts/loyalty-points/loyalty-points.module').then(m => m.LoyaltyPointsPageModule)
    },
    {
        path: 'profile',
        canActivate: [AuthGuard],
        loadChildren: () => import('./accounts/profile/profile.module').then(m => m.ProfilePageModule)
    },
    {
        path: 'change-password',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./accounts/change-password/change-password.module').then(m => m.ChangePasswordPageModule)
    },
    {
        path: 'address-lists',
        canActivate: [AuthGuard],
        loadChildren: () => import('./accounts/address-lists/address-lists.module').then(m => m.AddressListsPageModule)
    },
    {
        path: 'add-address',
        canActivate: [AuthGuard],
        loadChildren: () => import('./accounts/add-address/add-address.module').then(m => m.AddAddressPageModule)
    },
    {
        path: 'citylist',
        loadChildren: () => import('./pages/citylist/citylist.module').then(m => m.CitylistPageModule)
    },
    {
        path: 'settings',
        canActivate: [AuthGuard],
        loadChildren: () => import('./accounts/settings/settings.module').then(m => m.SettingsPageModule)
    },
    {
        path: 'reset-password',
        loadChildren: () => import('./accounts/reset-password/reset-password.module').then(m => m.ResetPasswordPageModule)
    },
    {
        path: 'home',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./home/home.module').then(m => m.HomePageModule)
    },
    {
        path: 'test',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./test/test.module').then(m => m.TestPageModule)
    },
    {
        path: 'home-appointment/:id',
        //canActivate: [AuthGuard],
        resolve: { home_service: DataResolverService },
        loadChildren: () => import('./home/home-appointment/home-appointment.module').then(m => m.HomeAppointmentPageModule)
    },
    {
        path: 'home-services',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./home/home-services/home-services.module').then(m => m.HomeServicesPageModule)
    },
    {
        path: 'book-home-appointment',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./home/book-home-appointment/book-home-appointment.module').then(m => m.BookHomeAppointmentPageModule)
    },
    {
        path: 'booking-success',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./home/booking-success/booking-success.module').then(m => m.BookingSuccessPageModule)
    },
    {
        path: 'booking-failed',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./home/booking-failed/booking-failed.module').then(m => m.BookingFailedPageModule)
    },
    {
        path: 'salon-branches',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./salon/salon-branches/salon-branches.module').then(m => m.SalonBranchesPageModule)
    },
    {
        path: 'salon',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./salon/salon.module').then(m => m.SalonPageModule)
    },
    {
        path: 'salon-appointment/:id',
        //canActivate: [AuthGuard],
        resolve: { salon_service: DataResolverService },
        loadChildren: () => import('./salon/salon-appointment/salon-appointment.module').then(m => m.SalonAppointmentPageModule)
    },
    {
        path: 'salon-services',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./salon/salon-services/salon-services.module').then(m => m.SalonServicesPageModule)
    },
    {
        path: 'book-salon-appointment',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./salon/book-salon-appointment/book-salon-appointment.module').then(m => m.BookSalonAppointmentPageModule)
    },
    {
        path: 'booking-confirmed',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./salon/booking-confirmed/booking-confirmed.module').then(m => m.BookingConfirmedPageModule)
    },
    {
        path: 'transaction-failed',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./salon/transaction-failed/transaction-failed.module').then(m => m.TransactionFailedPageModule)
    },
    {
        path: 'booking-history',
        loadChildren: () => import('./accounts/booking-history/booking-history.module').then(m => m.BookingHistoryPageModule)
    },
    {
        path: 'booking-details/:id',
        loadChildren: () => import('./accounts/booking-details/booking-details.module').then(m => m.BookingDetailsPageModule)
    },
    {
        path: 'package',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./package/package.module').then(m => m.PackagePageModule)
    },
    {
        path: 'product-branches',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./product/product-branches/product-branches.module').then(m => m.ProductBranchesPageModule)
    },
    {
        path: 'professional',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./professional/professional.module').then(m => m.ProfessionalPageModule)
    },
    {
        path: 'product',
        loadChildren: () => import('./product/product.module').then(m => m.ProductPageModule)
    },
    {
        path: 'product-cart',
        loadChildren: () => import('./product/product-cart/product-cart.module').then(m => m.ProductCartPageModule)
    },
    {
        path: 'buy-product',
        loadChildren: () => import('./product/buy-product/buy-product.module').then(m => m.BuyProductPageModule)
    },
    {
        path: 'order-confirmed',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./product/order-confirmed/order-confirmed.module').then(m => m.OrderConfirmedPageModule)
    },
    {
        path: 'order-failed',
        //canActivate: [AuthGuard],
        loadChildren: () => import('./product/order-failed/order-failed.module').then(m => m.OrderFailedPageModule)
    },
    {
        path: 'order-history',
        loadChildren: () => import('./product/order-history/order-history.module').then(m => m.OrderHistoryPageModule)
    },
    {
        path: 'order-details/:id',
        loadChildren: () => import('./product/order-details/order-details.module').then(m => m.OrderDetailsPageModule)
    },
  {
    path: 'payment-callback',
    loadChildren: () => import('./payment-callback/payment-callback.module').then( m => m.PaymentCallbackPageModule)
  },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule { }
